import {useSuspenseRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {Banner, Link} from '@primer/react'

import {repoStackDetailRoute} from '../../routes/repo-stack-detail-route'
import styles from './StackDetailHeader.module.css'

export function StackClosedBanner() {
  const {data} = useSuspenseRouteQuery(repoStackDetailRoute, 'mainQuery')
  const closedPullRequest = data.stack?.closedPullRequest
  if (!closedPullRequest) return null

  return (
    <Banner
      variant="critical"
      className={styles.ClosedBanner}
      title="This stack can't be fully merged"
      description={
        <>
          Pull request{' '}
          <Link inline href={closedPullRequest.url}>
            #{closedPullRequest.number}
          </Link>{' '}
          was closed without merging. Reopen it or unstack to unblock any upstack pull requests.
        </>
      }
    />
  )
}
